import ace from "./ace";
import diff from "./diff";
import split from "./split";
export { split, diff };
export default ace;
